export function Row({ children, gutter = 2 }) {
  return <section className={`row g-${gutter}`}>{children}</section>;
}
